/**
 * Utilities for an "instant" date/time.
 */
define([], () => ({
    /** Creates a new instant from JS date. */
    fromJSDate(date) {
        return date ? {'time': date.getTime()} : date;
    },

    /** Creates a new JS date from an instant. */
    toJSDate(instant) {
        return instant ? new Date(instant.time) : instant;
    }
}));


/** WEBPACK FOOTER **
 ** ./common/js/src/edge/platform/time/Instant.js
 **/